import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BenutzerService } from '../benutzer.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { SwapUser, User } from '../benutzer';
import { LocalStorageService } from './../../../../services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import { LoginService } from '../../../../services/user/login.service';
import { firstValueFrom } from 'rxjs';
import { KieneSession } from '../../../../services/local-storage/kiene-session';

@Component({
    selector: 'kiene-anmelden-als-anderer-benutzer-dialog',
    templateUrl: './anmelden-als-anderer-benutzer-dialog.component.html',
    styleUrls: ['./anmelden-als-anderer-benutzer-dialog.component.scss'],
})
export class AnmeldenAlsAndererBenutzerDialogComponent implements OnInit {
    AuthentifikationForm = new FormGroup({ AuthentKey: new FormControl() });
    generating = false;
    //Wurde der Button generieren gedrückt, und ein schlüssel verschickt?
    twoFaGenerated = false;
    authID = null;
    isLoading = false;
    constructor(
        public dialogRef: MatDialogRef<AnmeldenAlsAndererBenutzerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { user: User; currentuser: User },
        private userService: BenutzerService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private readonly router: Router,
        private loginService: LoginService,
    ) {}

    ngOnInit(): void {}

    onGenerate2Fa() {
        this.generating = true;
        const currentUser = this.data.currentuser;
        const targetUser = this.data.user;

        const swapToUser: SwapUser = {
            from_benutzer_id: currentUser.benutzer_id,
            to_benutzer: targetUser,
            authkey: null,
            authID: null,
        };

        this.userService.createAuthKey(swapToUser).subscribe(
            response => {
                this.authID = response;
                this.messageService.infoMessage('Auth Key wurde erfolgreich erstellt ');
                this.twoFaGenerated = true;
                this.generating = false;
            },
            error => {
                this.messageService.errorMessage('Authkey konnte nicht erstellt werden', error);
                this.generating = false;
            },
        );
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    //Dialog abschließen und die Verifikation ausführen.
    async safeAndCloseDialog() {
        if (this.AuthentifikationForm.valid) {
            const currentUser = this.data.currentuser;
            const targetUser = this.data.user;
            const authkey = this.AuthentifikationForm.get('AuthentKey')?.value;

            //Objekt, zum wechseln eines Benutzers
            const swapuser: SwapUser = {
                from_benutzer_id: currentUser.benutzer_id,
                to_benutzer: targetUser,
                authkey: authkey,
                authID: this.authID,
            };

            this.performUserSwap(swapuser);
        }
    }

    private performUserSwap(swapuser: SwapUser): void {
        const currentsession = this.localStorageService.getCurrentUser();
        this.userService.swapUser(swapuser).subscribe({
            next: (response: KieneSession) => {
                console.log(response);
                this.localStorageService.setCurrentUser(response);
                this.localStorageService.setCurrentClient(null, 'LoginService');
                const mandant = response.mandanten[0];
                this.localStorageService.setCurrentMandant(mandant);
                this.localStorageService.setSwappedUser(currentsession);
                location.reload();
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }
}
